<template>
  <div class="row">
    <div class="col-sm-12">
      <card>
        <!--Card Header-->
        <template slot="header">
          <h3 v-if="!imageMaxQuantityReached" class="mb-0">Cargar Imágenes de la Cotización (hasta 4 como máximo):</h3>
          <h3 v-else class="mb-0">Ha alcanzado el límite máximo de imágenes cargadas(4).</h3>
        </template>

        <template v-if="!imageMaxQuantityReached">
          <div class="row justify-content-center">
            <div class="col-md-8">
              <image-uploader
                ref="imageUploader"
                :max-allowed-quantity="maxAllowedQuantity"
                :images="picturesToUpload"
                :picture-quantity="pictureQuantity"
                @reset="reset"
                @upload="upload"
                @remove:image="removeImage"
                @add:image="addImage"
                @alert:count="countAlert"
              >
              </image-uploader>
            </div>
          </div>
        </template>
      </card>
    </div>
  </div>
</template>

<script>
import ImageUploader from '@/views/Quotations/Widgets/ImageUploader';
import swal from 'sweetalert2';

export default {
  name: 'QuotationImagesForm',
  components: {
    ImageUploader,
  },

  props: {
    quotationId: {
      type: Number,
      required: true,
    },

    maxAllowedQuantity: {
      type: Number,
      default: 4,
    },

    pictureQuantity: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      picturesToUpload: [],
    };
  },

  computed: {
    imageMaxQuantityReached() {
      return this.pictureQuantity === this.maxAllowedQuantity;
    },
  },

  methods: {
    addImage(image) {
      this.picturesToUpload.push(image);
    },

    countAlert() {
      swal({
        title: 'Error',
        text: 'La máxima cantidad de imágenes de una Cotización es ' + this.maxAllowedQuantity.toString(),
        type: 'error',
        buttonsStyling: false,
        confirmButtonText: 'OK',
        confirmButtonClass: 'btn btn-secondary',
      });
    },

    removeImage(index) {
      this.picturesToUpload.splice(index, 1);
    },

    reset() {
      this.picturesToUpload = [];
    },

    upload() {
      if (!this.quotationId) {
        return;
      }

      this.$services
        .resource('quotations')
        .attach(this.quotationId, this.picturesToUpload)
        .then(() => {
          this.reset();
          this.$refs.imageUploader.resetStats();
          this.$emit('fetchPictures');
        })
        .catch((e) => {});
    },
  },
};
</script>
